import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_4 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_5 = { class: "col-lg-8 fv-row" }
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-8 p-3 fv-row" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_38 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_41 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_42 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_43 = { class: "col-lg-8 fv-row" }
const _hoisted_44 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_45 = { class: "col-lg-10 fv-row fv-plugins-icon-container d-inline-block align-middle" }
const _hoisted_46 = ["download", "href"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "row mb-6" }
const _hoisted_52 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-lg-8 fv-row" }
const _hoisted_54 = {
  class: "dropzone",
  id: "kt_dropzonejs_nuevos_adjuntos"
}
const _hoisted_55 = { class: "dz-message needsclick" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_57 = { class: "ms-4" }
const _hoisted_58 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_59 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_62 = { class: "col-lg-8 fv-row" }
const _hoisted_63 = { class: "row mb-6" }
const _hoisted_64 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-lg-8 fv-row" }
const _hoisted_66 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_67 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_68 = { class: "col-lg-5 fv-row fv-plugins-icon-container" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { class: "fv-plugins-message-container" }
const _hoisted_73 = { class: "fv-help-block" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_77 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_78 = {
  key: 4,
  class: "row mb-6"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_80 = { class: "card mb-5 mb-xl-10" }
const _hoisted_81 = { class: "card-header border-0" }
const _hoisted_82 = { class: "card-title m-0" }
const _hoisted_83 = { class: "fw-bolder m-0" }
const _hoisted_84 = { class: "collapse show" }
const _hoisted_85 = { class: "card-body border-top p-9" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "row mb-6" }
const _hoisted_88 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_89 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_90 = { class: "row mb-6" }
const _hoisted_91 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_92 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "row mb-6" }
const _hoisted_96 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_97 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_98 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_99 = { class: "row mb-6" }
const _hoisted_100 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_101 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_102 = { class: "col-lg-4 fv-row fv-plugins-icon-container" }
const _hoisted_103 = { key: 2 }
const _hoisted_104 = { key: 3 }
const _hoisted_105 = { key: 4 }
const _hoisted_106 = { class: "row my-6" }
const _hoisted_107 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_108 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_109 = { class: "row mb-6" }
const _hoisted_110 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_111 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_113 = { key: 5 }
const _hoisted_114 = { class: "row my-6" }
const _hoisted_115 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_116 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_118 = { class: "card mb-5 mb-xl-10" }
const _hoisted_119 = { class: "card-body p-9" }
const _hoisted_120 = { class: "container d-inline-flex align-items-center p-0 mb-8" }
const _hoisted_121 = { class: "ms-6" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("i", { class: "fas fs-3 fa-info-circle me-1" }, null, -1)
const _hoisted_123 = { class: "container d-inline-flex align-items-center p-0 mb-4" }
const _hoisted_124 = { class: "fw-bold fs-6 me-4" }
const _hoisted_125 = { class: "container d-inline-flex align-items-center p-0 mb-8" }
const _hoisted_126 = { class: "fw-bold fs-6 me-4" }
const _hoisted_127 = { style: {"text-align":"center"} }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-comment cadetblue fa-lg",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DrawerHorario = _resolveComponent("DrawerHorario")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_ServiciosColectivosSolicitadosTabla = _resolveComponent("ServiciosColectivosSolicitadosTabla")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ProfesionalesTablaDisponibles = _resolveComponent("ProfesionalesTablaDisponibles")!
  const _component_ProfesionalesTablaAsignados = _resolveComponent("ProfesionalesTablaAsignados")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _component_IncluirMenorServicioModal = _resolveComponent("IncluirMenorServicioModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Page, { showBack: "" }, {
      actions: _withCtx(() => [
        (!_ctx.isCreate)
          ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 0,
              class: "mx-3"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, {
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#mau_modal_incluir_menor_servicio"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.inscribirMenor")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_divider, { class: "my-2" }),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _ctx.eliminar,
                      disabled: _ctx.solicitudes.length || _ctx.menores.length
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.eliminar")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "default" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_arrow_down)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.submit,
          loading: _ctx.crearServicioProgramado || _ctx.actualizarServicioProgramado
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isCreate ? _ctx.$t("page.acciones.crear") : _ctx.$t("page.acciones.guardar")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          type: "border-card",
          onTabClick: _ctx.tabClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.servicioProgramado.tab.informacion')
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("formularios.servicioProgramado.comarca.label")), 1),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.comarcaId,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comarcaId) = $event)),
                              class: "w-100",
                              disabled: !_ctx.isCreate
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.text,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"]),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_ErrorMessage, { name: "comarcaId" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("formularios.servicioProgramado.nombre.label")), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "nombre",
                            placeholder: " ",
                            modelValue: _ctx.nombre,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_ErrorMessage, { name: "nombre" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("formularios.servicioProgramado.descripcion.label")), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.descripcion,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.descripcion) = $event)),
                          rows: 3,
                          autosize: { minRows: 2 },
                          type: "textarea",
                          placeholder: " "
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_ErrorMessage, { name: "descripcion" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t(
                    "formularios.servicioProgramado.lugarEspacioColectivo.label"
                  )), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_el_select, {
                          name: "lugarEspacioColectivo",
                          modelValue: _ctx.lugarEspacioColectivo,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lugarEspacioColectivo) = $event)),
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lugaresEspaciosColectivos, (lugarColectivo, i) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                value: lugarColectivo.id,
                                label: lugarColectivo.nombre,
                                key: i
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(lugarColectivo.nombre), 1)
                                ]),
                                _: 2
                              }, 1032, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "lugarEspacioColectivo",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    (_ctx.lugarEspacioColectivo == 'OTROS')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t(
                    "formularios.servicioProgramado.otrosEspacioColectivo.label"
                  )), 1),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_el_input, {
                              name: "otrosEspacioColectivo",
                              modelValue: _ctx.otrosEspacioColectivo,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.otrosEspacioColectivo) = $event)),
                              type: "text",
                              placeholder: " "
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "otrosEspacioColectivo",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("formularios.servicioProgramado.direccion.label")), 1),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_el_input, {
                          name: "direccion",
                          modelValue: _ctx.direccion,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.direccion) = $event)),
                          type: "text",
                          placeholder: " "
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "direccion",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("formularios.servicioProgramado.plazas.label")), 1),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.plazas,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.plazas) = $event)),
                          min: 1
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "plazas",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t(
                    "formularios.servicioProgramado.inscripcionesAbiertas.label"
                  )), 1),
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.inscripcionesAbiertas,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inscripcionesAbiertas) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "inscripcionesAbiertas",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("formularios.servicioProgramado.icono.label")), 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.iconoCls,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.iconoCls) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconosServicios, (icono) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: icono.cls,
                                label: icono.label,
                                value: icono.cls
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa-lg img-fluid mx-auto textoCentrado me-3", icono.cls])
                                  }, null, 2),
                                  _createElementVNode("span", null, _toDisplayString(icono.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "iconoCls",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    (_ctx.url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("formularios.servicioProgramado.url.label")), 1),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.url), 1),
                            (_ctx.isSupported)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  icon: _ctx.Link,
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copy())),
                                  class: "ms-5"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.copied ? _ctx.$t("clipboard.copiado") : _ctx.$t("clipboard.copiar")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["icon"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.documentos.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("formularios.servicioProgramado.adjuntos.label")), 1),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("ul", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentos, (file, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i,
                                  class: "el-upload-list__item is-success",
                                  tabindex: "0"
                                }, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("a", {
                                      class: "el-upload-list__item-name",
                                      download: `${_ctx.nombre}-${file.nombre}`,
                                      href: file.blob
                                    }, [
                                      _createVNode(_component_el_image, {
                                        class: "align-middle",
                                        style: {"width":"100px","height":"100px"},
                                        src: file.blob,
                                        fit: "cover"
                                      }, {
                                        error: _withCtx(() => [
                                          _hoisted_47
                                        ]),
                                        _: 2
                                      }, 1032, ["src"]),
                                      _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                    ], 8, _hoisted_46)
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "col-1 d-inline-block btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                    onClick: ($event: any) => (_ctx.removeDocumento(i))
                                  }, _hoisted_50, 8, _hoisted_48)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("formularios.servicioProgramado.nuevosAdjuntos.label")), 1),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.$t(
                            "formularios.servicioProgramado.nuevosAdjuntos.accion"
                          )), 1),
                              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t(
                          "formularios.servicioProgramado.nuevosAdjuntos.descripcion"
                        )), 1)
                            ])
                          ])
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          name: "certificadoAntecedentes",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("formularios.servicioProgramado.fechasPrevistas.label")), 1),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_el_date_picker, {
                          format: "DD/MM/YYYY",
                          modelValue: _ctx.fechasPrevistas,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fechasPrevistas) = $event)),
                          type: "daterange",
                          "range-separator": "a",
                          class: "w-100"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("formularios.servicioProgramado.diasHoras.label")), 1),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("ul", _hoisted_66, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiempos, (tiempo, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: "row"
                            }, [
                              _createElementVNode("div", _hoisted_67, [
                                _createVNode(_component_el_select, {
                                  modelValue: tiempo.dias,
                                  "onUpdate:modelValue": ($event: any) => ((tiempo.dias) = $event),
                                  class: "w-100",
                                  multiple: "",
                                  placeholder: 
                          _ctx.$t('formularios.servicioProgramado.dias.label')
                        
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dias, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _createVNode(_component_el_select, {
                                  modelValue: tiempo.horas,
                                  "onUpdate:modelValue": ($event: any) => ((tiempo.horas) = $event),
                                  class: "w-100",
                                  multiple: "",
                                  placeholder: 
                          _ctx.$t('formularios.servicioProgramado.horarios.label')
                        
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horarios, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                onClick: ($event: any) => (_ctx.removeHorario(i))
                              }, _hoisted_71, 8, _hoisted_69)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createVNode(_component_ErrorMessage, { name: "tiempos" })
                          ])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addHorario && _ctx.addHorario(...args)))
                        }, [
                          _hoisted_74,
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioProgramado.diasHoras.añadirHorario")), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.generarFechas
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.fechas?.length > 0
                        ? _ctx.$t(
                            "formularios.servicioDetalle.reconfigurarFechas.button"
                          )
                        : _ctx.$t("formularios.servicioDetalle.generarFechas.button")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            disabled: !_ctx.fechasModificadas,
                            type: "primary",
                            onClick: _ctx.submit,
                            loading: 
                      _ctx.crearServicioProgramado || _ctx.actualizarServicioProgramado
                    
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("listados.familiaDetalle.guardar.button")), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick", "loading"])
                        ])
                      ])
                    ]),
                    (_ctx.fechas)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _createVNode(_component_el_table, {
                            data: _ctx.fechas,
                            style: {"width":"100%"},
                            stripe: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "fechaToShow",
                                label: _ctx.$t('formularios.servicioProgramado.cabecera.fecha')
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                prop: "diaSemana",
                                label: 
                    _ctx.$t('formularios.servicioProgramado.cabecera.diaSemana')
                  
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                prop: "hora",
                                label: _ctx.$t('formularios.servicioProgramado.cabecera.hora')
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_table_column, { width: "120" }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_button, {
                                    type: "text",
                                    onClick: ($event: any) => (_ctx.borrarFecha(scope.$index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioProgramado.borrar.button")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.drawer = true))
                    }, [
                      _hoisted_79,
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioProgramado.añadirFecha.button")), 1)
                    ]),
                    _createVNode(_component_DrawerHorario, {
                      onAceptar: _ctx.drawerAceptar,
                      cerrar: _ctx.drawerCerrar,
                      display: _ctx.drawer
                    }, null, 8, ["onAceptar", "cerrar", "display"])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            (!_ctx.isCreate)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 0,
                  label: _ctx.$t('formularios.servicioProgramado.tab.solicitudes')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _withDirectives(_createVNode(_component_ServiciosColectivosSolicitadosTabla, { servicios: _ctx.solicitudes }, null, 8, ["servicios"]), [
                        [_directive_loading, false]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (!_ctx.isCreate)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 1,
                  disabled: !_ctx.enableTabProfesional,
                  label: _ctx.$t('formularios.servicioProgramado.tab.profesionales'),
                  name: "profesionales"
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      disabled: _ctx.enableTabProfesional,
                      content: 
              _ctx.$t('formularios.servicioProgramado.tab.profesionalesTooltip')
            
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("formularios.servicioProgramado.tab.profesionales")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "content"])
                  ]),
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("h3", _hoisted_83, _toDisplayString(_ctx.$t("formularios.servicioDetalle.profesionalesAsignados", {
                    inicioPrevisto: _ctx.inicioPrevistoFormateado,
                    finPrevisto: _ctx.finPrevistoFormateado,
                  })), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          (!_ctx.busquedaProfesional && !_ctx.profesionalesAsignados)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                _createElementVNode("div", _hoisted_87, [
                                  _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("div", _hoisted_89, [
                                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t(
                            "formularios.servicioDetalle.servicioSinAsignar.label"
                          )), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("div", _hoisted_91, [
                                    _createElementVNode("div", _hoisted_92, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-primary text-uppercase mb-5",
                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.busquedaProfesional = true))
                                      }, [
                                        _hoisted_93,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t(
                            "formularios.servicioDetalle.buscarProfesional.button"
                          )), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.busquedaProfesional)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                _createElementVNode("div", _hoisted_95, [
                                  _createElementVNode("div", _hoisted_96, [
                                    _createVNode(_component_el_select, {
                                      name: "vehiculoPropio",
                                      clearable: "",
                                      modelValue: _ctx.vehiculoPropio,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.vehiculoPropio) = $event)),
                                      placeholder: 
                        _ctx.$t('formularios.servicioDetalle.vehiculoPropio.label')
                      ,
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehiculos, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: item.nombre,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "placeholder"])
                                  ]),
                                  _createElementVNode("div", _hoisted_97, [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.idioma,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.idioma) = $event)),
                                      clearable: "",
                                      multiple: "",
                                      placeholder: 
                        _ctx.$t('formularios.servicioDetalle.idiomas.label')
                      ,
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nombreIdioma, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: item.text,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "placeholder"])
                                  ]),
                                  _createElementVNode("div", _hoisted_98, [
                                    _createVNode(_component_el_tooltip, {
                                      class: "box-item",
                                      effect: "dark",
                                      content: 
                        _ctx.$t(
                          'formularios.servicioDetalle.disponeTitulacion.tooltip'
                        )
                      ,
                                      placement: "top"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.disponeTitulacion,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.disponeTitulacion) = $event)),
                                          clearable: "",
                                          placeholder: 
                          _ctx.$t('formularios.servicioDetalle.titulacion.label')
                        ,
                                          style: {"width":"100%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              key: "true",
                                              label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.titulacion.opcionSi'
                            )
                          ,
                                              value: true
                                            }, null, 8, ["label"]),
                                            _createVNode(_component_el_option, {
                                              key: "false",
                                              label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.titulacion.opcionNo'
                            )
                          ,
                                              value: false
                                            }, null, 8, ["label"])
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "placeholder"])
                                      ]),
                                      _: 1
                                    }, 8, ["content"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_99, [
                                  _createElementVNode("div", _hoisted_100, [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.experienciaCuidadoMenores,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.experienciaCuidadoMenores) = $event)),
                                      clearable: "",
                                      placeholder: 
                        _ctx.$t(
                          'formularios.servicioDetalle.experienciaCuidadoMenores.label'
                        )
                      ,
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_option, {
                                          value: "EXPERIENCIAPROFESIONAL",
                                          label: 
                          _ctx.$t(
                            'formularios.servicioDetalle.experienciaCuidadoMenores.EXPERIENCIAPROFESIONAL'
                          )
                        
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_el_option, {
                                          value: "EXPERIENCIANOPROFESIONAL",
                                          label: 
                          _ctx.$t(
                            'formularios.servicioDetalle.experienciaCuidadoMenores.EXPERIENCIANOPROFESIONAL'
                          )
                        
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_el_option, {
                                          value: "SINEXPERIENCIA",
                                          label: 
                          _ctx.$t(
                            'formularios.servicioDetalle.experienciaCuidadoMenores.SINEXPERIENCIA'
                          )
                        
                                        }, null, 8, ["label"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "placeholder"])
                                  ]),
                                  _createElementVNode("div", _hoisted_101, [
                                    _createVNode(_component_el_tooltip, {
                                      class: "box-item",
                                      effect: "dark",
                                      content: 
                        _ctx.$t(
                          'formularios.servicioDetalle.disponiblidadEspecial.tooltip'
                        )
                      ,
                                      placement: "top"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.disponiblidadEspecial,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.disponiblidadEspecial) = $event)),
                                          clearable: "",
                                          multiple: "",
                                          placeholder: 
                          _ctx.$t('formularios.servicioDetalle.disponibilidad.label')
                        ,
                                          style: {"width":"100%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              key: "laborables",
                                              label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.laborables'
                            )
                          ,
                                              value: "laborables"
                                            }, null, 8, ["label"]),
                                            _createVNode(_component_el_option, {
                                              key: "finesDeSemana",
                                              label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.finesDeSemana'
                            )
                          ,
                                              value: "finesDeSemana"
                                            }, null, 8, ["label"]),
                                            _createVNode(_component_el_option, {
                                              key: "festivos",
                                              label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.festivos'
                            )
                          ,
                                              value: "festivos"
                                            }, null, 8, ["label"]),
                                            _createVNode(_component_el_option, {
                                              key: "noches",
                                              label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.noches'
                            )
                          ,
                                              value: "noches"
                                            }, null, 8, ["label"]),
                                            _createVNode(_component_el_option, {
                                              key: "urgencias",
                                              label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.urgencias'
                            )
                          ,
                                              value: "urgencias"
                                            }, null, 8, ["label"])
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "placeholder"])
                                      ]),
                                      _: 1
                                    }, 8, ["content"])
                                  ]),
                                  _createElementVNode("div", _hoisted_102, [
                                    _createVNode(_component_el_checkbox, {
                                      modelValue: _ctx.verSoloDisponibles,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.verSoloDisponibles) = $event)),
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(
                          "formularios.servicioDetalle.verSoloDisponibles.label"
                        )), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.busquedaProfesional && _ctx.profesionalesFiltrados)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                _createVNode(_component_ProfesionalesTablaDisponibles, {
                                  profesionales: _ctx.profesionalesFiltrados,
                                  inicioPrevisto: _ctx.inicioPrevisto,
                                  finPrevisto: _ctx.finPrevisto,
                                  comarcaId: _ctx.comarcaValor,
                                  servicioId: _ctx.servicioId
                                }, null, 8, ["profesionales", "inicioPrevisto", "finPrevisto", "comarcaId", "servicioId"])
                              ]))
                            : _createCommentVNode("", true),
                          (
                  !_ctx.busquedaProfesional &&
                  _ctx.profesionalesAsignadosFilas &&
                  _ctx.profesionalesAsignados
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                _createVNode(_component_ProfesionalesTablaAsignados, {
                                  profesionales: _ctx.profesionalesAsignadosFilas,
                                  inicioPrevisto: _ctx.inicioPrevisto,
                                  finPrevisto: _ctx.finPrevisto,
                                  comarcaId: _ctx.comarcaValor,
                                  servicioId: _ctx.servicioId
                                }, null, 8, ["profesionales", "inicioPrevisto", "finPrevisto", "comarcaId", "servicioId"])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.busquedaProfesional && _ctx.profesionalesAsignados)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("div", _hoisted_107, [
                                    _createElementVNode("div", _hoisted_108, [
                                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t(
                            "formularios.servicioDetalle.servicioConProfesionalesAsignados.label"
                          )), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("div", _hoisted_110, [
                                    _createElementVNode("div", _hoisted_111, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-primary text-uppercase mb-5",
                                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.busquedaProfesional = true))
                                      }, [
                                        _hoisted_112,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t(
                            "formularios.servicioDetalle.buscarProfesional.button"
                          )), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.busquedaProfesional && _ctx.profesionalesAsignados)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                _createElementVNode("div", _hoisted_114, [
                                  _createElementVNode("div", _hoisted_115, [
                                    _createElementVNode("div", _hoisted_116, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-primary text-uppercase mb-5",
                                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.busquedaProfesional = false))
                                      }, [
                                        _hoisted_117,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("formularios.servicioDetalle.volver.button")), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.cargaDetalle]
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "label"]))
              : _createCommentVNode("", true),
            (!_ctx.isCreate)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 2,
                  label: _ctx.$t('formularios.servicioProgramado.tab.encuesta'),
                  name: "encuesta"
                }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_118, [
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.enviarEncuestaTodos
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioProgramado.encuestas.enviar.button")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createElementVNode("span", _hoisted_121, [
                            _hoisted_122,
                            _createElementVNode("span", null, _toDisplayString(!_ctx.fechaEnvioEncuesta
                      ? _ctx.$t(
                          "formularios.servicioProgramado.encuestas.info.noEnviado"
                        )
                      : _ctx.$t(
                          "formularios.servicioProgramado.encuestas.info.enviado",
                          {
                            fecha: _ctx.fechaEnvioEncuesta,
                          }
                        )), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_123, [
                          _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t("formularios.servicioProgramado.encuestas.media.label")), 1),
                          _createVNode(_component_el_rate, {
                            modelValue: _ctx.satisfaccion.media,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.satisfaccion.media) = $event)),
                            disabled: "",
                            colors: _ctx.colors,
                            "show-score": "",
                            "text-color": "#ff9900",
                            "score-template": "{value}"
                          }, null, 8, ["modelValue", "colors"])
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("label", _hoisted_126, _toDisplayString(_ctx.$t(
                    "formularios.servicioProgramado.encuestas.respuestas.label"
                  )), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t(
                    "formularios.servicioProgramado.encuestas.respuestas.field",
                    {
                      realizados: _ctx.satisfaccion.respuestas,
                      total: _ctx.menores.length,
                    }
                  )), 1)
                        ]),
                        _createVNode(_component_el_table, {
                          data: _ctx.menores,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              label: 
                  _ctx.$t(
                    'tabla.serviciosColectivosAdmitidosListado.cabecera.menores'
                  )
                ,
                              prop: "menoresNombres",
                              sortable: "",
                              "min-width": "150"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: 
                  _ctx.$t('tabla.serviciosColectivosAdmitidosListado.cabecera.dni')
                ,
                              prop: "dni",
                              sortable: "",
                              width: "120"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: 
                  _ctx.$t(
                    'tabla.serviciosColectivosAdmitidosListado.cabecera.direccion'
                  )
                ,
                              prop: "direccion",
                              sortable: "",
                              "min-width": "150"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: 
                  _ctx.$t('tabla.serviciosColectivosAdmitidosListado.cabecera.email')
                ,
                              prop: "email",
                              sortable: "",
                              "min-width": "150"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              width: "120",
                              fixed: "right",
                              label: 
                  _ctx.$t(
                    'tabla.serviciosColectivosAdmitidosListado.cabecera.comentario'
                  )
                
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_127, [
                                  (scope.row.respuestaEncuesta?.comentario)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        size: "small",
                                        type: "text",
                                        onClick: ($event: any) => (_ctx.verComentario(scope.row))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_128
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              width: "150",
                              fixed: "right"
                            }, {
                              default: _withCtx((scope) => [
                                (!scope.row.respuestaEncuesta)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      size: "small",
                                      type: "text",
                                      onClick: ($event: any) => (_ctx.enviarEncuesta(scope.row))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.servicioProgramado.encuestas.enviarEncuestaFamilia"
                      )), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_el_rate, {
                                      key: 1,
                                      modelValue: scope.row.respuestaEncuesta.puntuacion,
                                      "onUpdate:modelValue": ($event: any) => ((scope.row.respuestaEncuesta.puntuacion) = $event),
                                      disabled: "",
                                      colors: _ctx.colors
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "colors"]))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ])
                    ])), [
                      [_directive_loading, _ctx.cargaDetalle]
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onTabClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_IncluirMenorServicioModal)
  ], 64))
}